import {
    useAiModels,
    useOrganizationAiModels,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation } from "@tanstack/react-query";

/** Catalogue des modèles d'IA de l'organisation et sélection du modèle actif. */
const useOrganizationAiModel = () => {
    const aiModels = useAiModels();
    const { data, isLoading, error } = useOrganizationAiModels();

    const { mutateAsync: assignOrganizationAiModel, isPending: isUpdating } =
        useMutation({
            mutationFn: (modelId: string) =>
                aiModels.assignOrganizationAiModel(modelId),
        });

    return {
        availableModels: data?.availableModels ?? [],
        currentModelId: data?.currentModelId,
        isLoading,
        isError: !!error,
        isUpdating,
        assignOrganizationAiModel,
    };
};

export default useOrganizationAiModel;
